export abstract class StorageHandler {

    protected loggerEnabled = false;

    constructor(public readonly origin: string, public readonly key: string) {
        // this.loggerEnabled = true;
    }

    protected logger(msg: string, val?: any): void {
        if (this.loggerEnabled) 
            console.log(`Storage Message: ${this.origin} storage for type - ${this.key} - Msg - ${msg} `, val);
    }

    protected loggerError(msg: string, val?: any): void {
        console.error(`Storage Error Message: ${this.origin} storage for type - ${this.key} - Error Msg - ${msg} `, val);
    }
}



// WEBPACK FOOTER //
// ./src/core/services/storage/handlers/storage-handler.ts